module.exports = __webpack_public_path__ + "static/turquia-022-af15ccde0cef7538bb6655b50b696403.jpg";